import {Pipe, PipeTransform} from '@angular/core';

import {iconNameForCustomPropertyAndPropertyType} from '../../util/icon.util';

@Pipe({name: 'iconNameForCustomPropertyAndPropertyType'})
export class IconNameForCustomPropertyAndPropertyTypePipe implements PipeTransform {
  transform(type: string): string {
    return iconNameForCustomPropertyAndPropertyType(type);
  }
}
